import styled, { css } from 'styled-components';
import Icon from '../../../_shared/components/Icon';
import Badge from '../../../_shared/components/Badge';
import Button from '../../../_shared/components/Button';
import isOmpPlatform from '../../../_shared/utils/isOmpPlatform';

const isOmp = isOmpPlatform();

export const CloseIcon = styled(Icon).attrs({
  icon: 'TR5-Close_X'
})`
  width: 18px;
  height: 18px;
`;

export const CloseButton = styled.button`
  display: inherit;
  border: none;
  outline: none;
  cursor: pointer;
  background-color: ${({ theme }) => theme.COLORS.BASE};
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;

  ${() =>
    isOmp &&
    css`
      width: unset;
      height: unset;
    `}
`;

export const Header = styled.div`
  display: flex;
  flex-flow: column;
  align-items: flex-start;
  padding: 0px;
  background-color: ${({ theme }) => theme.COLORS.BASE};
  box-shadow: 0px 6px 24px rgba(0, 0, 0, 0.2);
`;

export const HeaderMain = styled.div`
  display: flex;
  flex-flow: row;
  align-items: center;
  padding: 18px;
  background-color: ${({ theme }) => theme.COLORS.BASE};
  width: 100%;
  ${() =>
    isOmp &&
    css`
      border-bottom: 1px solid ${({ theme }) => theme.COLORS.NEUTRAL_110};
    `}
`;

export const SubHeader = styled.div`
  width: 100%;
  display: flex;
  padding: 11px 18px;
  background-color: ${({ theme }) => theme.COLORS.NEUTRAL};
  & > div {
    margin-right: 24px;
    font-style: normal;
    font-family: ${({ theme }) => theme.FONT.REGULAR};
    font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};
    line-height: 14px;
    color: ${({ theme }) => theme.COLORS.BLACK};
  }

  ${() =>
    isOmp &&
    css`
      border-bottom: 1px solid ${({ theme }) => theme.COLORS.NEUTRAL_110};
      box-shadow: 0 4px 10px -10px ${({ theme }) => theme.COLORS.BLACK};
    `}
`;

const styleTextEllipsis = css`
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;

export const Year = styled(Badge)`
  border: 2px solid ${({ theme }) => theme.COLORS.BASE_INVERTED};
  font-family: ${({ theme }) => theme.FONT.SEMI_BOLD};
  color: ${({ theme }) => theme.COLORS.BASE_INVERTED};
  font-size: ${({ theme }) => theme.FONT_SIZES.LARGE};
  margin-left: 12px;
  padding: 0 5px;
  line-height: 1;
  border-radius: 5.5px;
`;

export const Make = styled.span`
  padding-right: 6px;
  color: ${({ theme }) => theme.COLORS.BASE_INVERTED};
  font-size: ${({ theme }) => theme.FONT_SIZES.XLARGE};
`;

export const Model = styled.span`
  margin-left: 6px;
  color: ${({ theme }) => theme.COLORS.BASE_INVERTED};
  font-family: ${({ theme }) => theme.FONT.SEMI_BOLD};
  font-size: ${({ theme }) => theme.FONT_SIZES.XLARGE};
  ${styleTextEllipsis}
`;

export const MakeModel = styled.div`
  padding-left: 10px;
  padding-right: 6px;
  // Need a fixed width here so that "As-is" and "2015" is not squeeezed.
  // min-width with the "as-is" icon, max-width otherwise.
  min-width: 245px;
  max-width: ${props => (props.showAsIsIcon ? '245px' : '360px')};
  ${styleTextEllipsis};
`;

export const AsIs = styled(Badge)`
  background-color: ${({ theme }) => theme.COLORS.ORANGE};
  border-radius: 18px;
  margin-left: 8px;
  font-family: ${({ theme }) => theme.FONT.SEMI_BOLD};
  font-size: ${({ theme }) => theme.FONT_SIZES.BASE};
  text-align: center;
  height: 30px;
  width: 60px;
  padding: 3px 0px 3px 0px;
`;

export const NegotiationContent = styled.div`
  width: 100%;
  height: 200px;
  background: ${({ theme }) => theme.COLORS.NEUTRAL_50};
  border-radius: 0px;
  font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};
  color: ${({ theme }) => theme.COLORS.NEUTRAL_30};
  flex: 1 1 auto;
  overflow-y: auto;
  display: block;

  & > div.content {
    display: flex;
    justify-content: flex-end;
    flex-direction: column;
    min-height: 200px;
    padding: 10px 12px;
  }

  ${() =>
    isOmp &&
    css`
      background: ${({ theme }) => theme.COLORS.NEUTRAL};
      border-bottom: 1px solid ${({ theme }) => theme.COLORS.NEUTRAL_110};
    `}
`;

export const OfferStatusWrapper = styled.div`
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  padding: 14px 18px;
  background-color: ${({ theme }) => theme.COLORS.NEUTRAL};

  & div#offer {
    & > p {
      font-style: normal;
      font-family: ${({ theme }) => theme.FONT.REGULAR};
      font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};
      line-height: 14px;
      color: ${({ theme }) => theme.COLORS.NEUTRAL_30};
      margin: 1px;
    }
    & > span {
      font-style: normal;
      font-family: ${({ theme }) => theme.FONT.SEMI_BOLD};
      font-size: ${({ theme }) => theme.FONT_SIZES.LARGE};
      line-height: 24px;
      letter-spacing: -0.5px;
      color: ${({ theme }) => theme.COLORS.BLACK};
    }
  }
`;

const baseButton = css`
  font-style: normal;
  font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};
  font-family: ${({ theme }) => theme.FONT.SEMI_BOLD};
  line-height: 14px;
  text-align: center;
  letter-spacing: 1.37143px;
  text-transform: ${({ theme }) => theme.BUTTON.TEXT_TRANSFORM};
  padding-top: 12px;
  padding-bottom: 13px;
  min-width: 104px;

  ${() =>
    isOmp &&
    css`
      letter-spacing: 0;
      font-family: ${({ theme }) => theme.FONT.BOLD};
      text-transform: none;
    `}
`;

export const ButtonPrimary = styled(Button.Primary)`
  ${baseButton}
`;

export const ButtonSendOffer = styled(ButtonPrimary)`
  ${baseButton}
  width: 100%;
`;

export const ButtonTransparent = styled(Button.Transparent)`
  ${baseButton}
  padding: 12px 3px;
  height: 36px;
`;

export const ButtonSecondary = styled(Button.Secondary)`
  ${baseButton}
`;

export const LinkPrimary = styled(ButtonTransparent)`
  color: ${({ theme }) => theme.COLORS.TERTIARY};
  min-width: 0px;
  padding: 0;
  margin-top: -5px;
  height: auto;
`;

export const NegotiationActions = styled.div`
  padding: 17px 18px 19px 19px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const CancelButtonWrapper = styled(NegotiationActions)`
  align-items: flex-start;
  flex-direction: column;
  margin-bottom: -25px;
`;

export const NegotiationActionsRightWrapper = styled.div`
  display: flex;
  & > button {
    margin-left: 13px;
  }
`;

export const StyledForm = styled.fieldset`
  display: flex;
  margin: 12px 0px;
  flex-direction: column;
  border: none;
`;

export const StyledSecondBidderForm = styled(StyledForm)`
  margin: 0px;
  background-color: ${({ theme }) => theme.COLORS.BASE};
  padding: 24px 18px 18px 18px;
`;

export const SecondBidderOfferStatusWrapper = styled(OfferStatusWrapper)`
  background-color: ${({ theme }) => theme.COLORS.BASE};
  padding: 0px;
`;

export const SecondBidderOfferLabel = styled.div`
  color: ${({ theme }) => theme.COLORS.BLACK};
  font-style: normal;
  font-family: ${({ theme }) => theme.FONT.REGULAR};
  font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};
  line-height: 14px;
  margin: 1px;
`;

export const Row = styled.div`
  display: flex;
`;

export const Footer = styled(Row)`
  align-items: flex-end;
  width: 100%;
`;

export const SecondBidderFooter = styled(Footer)`
  justify-content: flex-end;
  align-items: baseline;
  & > button {
    margin-left: 18px;
  }
`;

export const StayFirmWrapper = styled(Row)`
  justify-content: flex-end;
  margin-top: 12px;
`;

export const NewOfferTip = styled.div`
  margin-left: 18px;
  font-family: ${({ theme }) => theme.FONT.REGULAR};
  font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};
  font-family: ${({ theme }) => theme.FONT.REGULAR};
  & > span {
    font-family: ${({ theme }) => theme.FONT.SEMI_BOLD};
  }
`;

const StyledFormItemLabelVariants = {
  error: css`
    color: ${({ theme }) => theme.COLORS.ERROR};
  `
};

const StyledFormItemInputVariants = {
  error: css`
    border: 2px solid ${({ theme }) => theme.COLORS.ERROR};
  `
};

const StyledFormItem = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 18px;
`;

StyledFormItem.Label = styled.label`
  font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};
  font-family: ${({ theme }) => theme.FONT.REGULAR};
  color: ${({ theme }) => theme.COLORS.BASE_INVERTED};
  margin-bottom: 6px;
  ${({ isInvalid, theme }) =>
    isInvalid ? `color: ${theme.COLORS.MONZA};` : ''}

  ${({ variant }) => StyledFormItemLabelVariants[variant]}
  & > span {
    color: ${({ theme }) => theme.COLORS.NEUTRAL_30};
    margin-right: 6px;
  }
`;

StyledFormItem.LabelWithHintWrapper = styled(Row)`
  justify-content: space-between;
`;

StyledFormItem.Wrapper = styled.div`
  height: 36px;
  display: flex;
  align-items: center;
`;

StyledFormItem.Input = styled.input`
  width: 216px;
  height: 36px;
  border: 1px solid ${({ theme }) => theme.COLORS.NEUTRAL_20};
  border-radius: 3px;
  padding: 12px;
  font-family: ${({ theme }) => theme.FONT.REGULAR};
  font-size: ${({ theme }) => theme.FONT_SIZES.BASE};
  ${({ isInvalid, theme }) =>
    isInvalid ? `border: 2px solid ${theme.COLORS.MONZA};` : ''}

  ${({ variant }) => StyledFormItemInputVariants[variant]}

  &:disabled {
    cursor: not-allowed;
  }

  &:focus {
    outline: none;
  }
`;

StyledFormItem.TextAreaWrapper = styled(StyledFormItem)`
  margin-bottom: 0px;
`;

StyledFormItem.TextArea = styled.textarea`
  height: 72px;
  width: 318px;
  margin-right: 6px;
  padding: 12px;
  font-family: ${({ theme }) => theme.FONT.REGULAR};
  font-size: ${({ theme }) => theme.FONT_SIZES.BASE};
  line-height: 16px;
  border: 1px solid ${({ theme }) => theme.COLORS.NEUTRAL_20};
`;

export { StyledFormItem };

const ProposalLeft = css`
  margin-left: 76px;
`;
const ProposalRight = css`
  margin-right: 76px;
`;

const StyledProposal = styled.div`
  display: flex;
  flex-direction: column;
  ${props => (props.isHost ? ProposalLeft : ProposalRight)}
`;

export const StyledNegotiationEnded = styled.div`
  margin-top: 17px;
  margin-bottom: -19px;
`;

const GuestBubbleColour = css`
  background-color: ${({ theme }) => theme.COLORS.BASE};
`;

const HostBubbleColour = css`
  background: rgba(112, 112, 112, 0.1);

  ${() =>
    isOmp &&
    css`
      background: ${({ theme }) => theme.COLORS.NEUTRAL_5};
    `}
`;

StyledProposal.Bubble = styled.div`
  padding: 12px 10px;
  ${props => (props.isHost ? HostBubbleColour : GuestBubbleColour)}
  border-radius: 6px;
  color: black;
  ${() =>
    isOmp &&
    css`
      border: 1px solid ${({ theme }) => theme.COLORS.NEUTRAL_110};
    `}
`;
StyledProposal.Offer = styled.div`
  font-family: ${({ theme }) => theme.FONT.SEMI_BOLD};
  font-style: normal;
  font-size: ${({ theme }) => theme.FONT_SIZES.MEDIUM};
  line-height: 18px;
  margin-bottom: 6px;
`;

StyledProposal.Comment = styled.div`
  font-family: ${({ theme }) => theme.FONT.REGULAR};
  font-style: normal;
  font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};
  line-height: 14px;
  word-break: break-all;
`;

export { StyledProposal };

export const StyledYourOffer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 12px 18px;
`;

export const StyledYourOfferLabel = styled.label`
  color: ${({ theme }) => theme.COLORS.NEUTRAL_30};
  font-family: ${({ theme }) => theme.FONT.REGULAR};
  font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};
`;

export const StyledYourOfferValue = styled.span`
  color: ${({ theme }) => theme.COLORS.REGULAR};
  font-family: ${({ theme }) => theme.FONT.SEMI_BOLD};
  font-size: ${({ theme }) => theme.FONT_SIZES.LARGE};
  margin-top: 6px;
  line-height: 24px;
`;

export const NameContainer = styled.div`
  // Line up "RC" and "STAR DEALER CA 1 (RAJNEESH)"
  display: flex;
  width: 225px;
  align-items: center;
`;

export const DisplayName = styled.div`
  width: 195px;
  ${styleTextEllipsis}
`;

export const DealerInitial = styled.div`
  width: 30px;
  height: 30px;
  background: ${({ theme }) => theme.COLORS.NEUTRAL_30};
  color: ${({ theme }) => theme.COLORS.BASE};
  padding: 8px;
  border-radius: 20px;
  margin-right: 8px;
`;

export const ProposalDisplayContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  margin-bottom: 12px;
  margin-top: 30px;
  font-size: ${({ theme }) => theme.FONT_SIZES.XSMALL};

  ${() =>
    isOmp &&
    css`
      color: ${({ theme }) => theme.COLORS.BASE_INVERTED};
    `}
`;

export const NegotiationDate = styled.div`
  // Line up "RC" "STAR DEALER CA 1 (RAJNEESH)" to "Sept 30th at 10:13 am"
  margin: auto;
`;

export const NewOfferSeparator = styled.div`
  width: 100%;
  height: 8px;
  border-bottom: 1px solid red;
  text-align: right;
  display: flex;
  align-items: flex-start;
  flex-direction: row;
  justify-content: flex-end;
  margin-bottom: -7px;
  margin-top: 10px;

  & > span {
    font-size: 12px;
    background-color: ${({ theme }) => theme.COLORS.NEUTRAL_50};
    padding: 0 12px;
    color: #f95341;
  }

  ${() =>
    isOmp &&
    css`
      border-bottom: 1px solid ${({ theme }) => theme.COLORS.RED};

      & > span {
        padding: 0 8px;
        color: ${({ theme }) => theme.COLORS.RED};
        background-color: ${({ theme }) => theme.COLORS.NEUTRAL};
      }
    `}
`;
